<template>
  <DvShell>
    <template #sidenav>
      <div class="left-rail">
        <div
          id="team-information"
          class="left-rail-section"
        >
          <div class="logo">
            <img
              :src="logoImgSrc"
              :alt="orgFullName"
            />
          </div>
          <div class="team-select">
            <select
              id="team-select"
              @change="onSelectChanged"
            >
              <template v-for="org in appOrgData">
                <option
                  :key="org.OrgID"
                  :value="org.OrgID"
                  :selected="org.OrgID === orgID"
                >
                  {{ org.FullName }}
                </option>
              </template>
            </select>
          </div>
        </div>
        <template v-for="(page, i) in pages">
          <div
            :key="'page-' + i"
            class="left-rail-section"
            :class="{ selected: currentPage === page.key }"
            @click="loadPage(page)"
          >
            {{ page.text }}
          </div>
        </template>
      </div>
    </template>

    <template #content>
      <template v-if="isLoading">
        <LoadingSpinner
          :z-index="10"
          position="absolute"
        />
      </template>
      <div style="height: 100%; font-size: 12px">
        <router-view />
      </div>
    </template>
  </DvShell>
</template>

<script>
import { httpMixin } from '@baseball-systems/http';
import { notificationsMixin } from '@baseball-systems/notifications';

import LoadingSpinner from '@baseball-systems/LoadingSpinner';

import DvShell from 'library/components/Shell';

import { ORG_PAGES } from './utils/constants.js';

export default {
  components: {
    LoadingSpinner,
    DvShell,
  },
  mixins: [httpMixin, notificationsMixin],
  data() {
    return {
      orgID: 1,
      appOrgData: null,
      isLoading: false,
      pages: ORG_PAGES,
      currentPage: this.$route.name,
    };
  },
  computed: {
    currentOrgData() {
      return this.appOrgData?.find((x) => x.OrgID === this.orgID);
    },
    logoImgSrc() {
      return `/dv/images/logos_small/${this.currentOrgData?.MLAbbrev}.png`;
    },
    orgFullName() {
      return this.currentOrgData?.FullName;
    },
  },
  watch: {
    $route() {
      this.currentPage = this.$route.name;
    },
    'currentOrgData.MLAbbrev'(newVal) {
      if (newVal) {
        document.title = `${newVal} - Org View`;
        const favi = document.getElementById('favicon');
        if (favi) {
          favi.href = `/dv/images/logos_small/${newVal}.png`;
        }
      }
    },
  },
  async created() {
    await this.getAppOrgData();
  },
  mounted() {
    const orgID = Number(this.$route.query.oid);

    if (isNaN(orgID))
      this.orgID = 1; // default to CLE
    else this.orgID = orgID;
  },
  methods: {
    async getAppOrgData() {
      this.isLoading = true;
      const res = await this.request('/dvsvc/AppOrganizations/');

      if (res.IsError) {
        const message = `Unable to load orgs. Reason: '${res.Msg}'`;
        this.notifyDanger(message);
      } else {
        this.appOrgData = res.sort((a, b) => a.FullName.localeCompare(b.FullName));
      }

      this.isLoading = false;
    },
    loadPage(e) {
      if (this.currentPage !== e.key) {
        this.currentPage = e.key;
        this.$router.push(`${e.route}?oid=${this.orgID}`);
      }
    },
    onSelectChanged(ev) {
      this.orgID = Number(ev.target.value);
      this.$router.push(`${this.$route.path}?oid=${this.orgID}`);
    },
  },
};
</script>

<style lang="scss" scoped>
#team-information {
  background: transparent;
}
.logo {
  font-family: 'TribeType_DV';
  font-size: 16px;
  text-align: center;
}
.left-rail {
  height: 100%;
  background: $scouting-blue;
}
.left-rail-section {
  list-style-type: none;
  border-top: 1px solid $scouting-gray;
  border-bottom: 1px solid #222;
  background: darken($scouting-blue, 10%);
  padding: 5px;
  cursor: pointer;
  font-size: 12px;
  line-height: 16px;
  color: #fff;
  &.selected {
    background: darken($indBlue, 10%);
  }
}

.team-select {
  text-align: center;
}
</style>
